

import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import PropTypes from 'prop-types';
import hdrFilePath from '../../../../assets/glb/venice_sunset_1k.hdr';
import futuristicGlbb from '../../../../assets/glb/Futuristiclab.glb';




const defaultModelsActivity = {
  whoIsSpeaking: 'narrator', //on run time who is currently speaking
  playerEmotions: [], //['happy','surprised']
  npcEmotions: [], //['angry','ugly']
  cameraPosition: { x: 0, y: 0, z: 0 }, //
  playerModel: {
    isRequired: true, //default false
    scale: { x: 0.35, y: 0.4, z: 0.35 },
    position: { x: -3.5, y: 0, z: 2.2 },
    rotation: { x: 0, y: 11.5, z: 0 },
  },
  NpcModel: {
    isRequired: true, //default false
    scale: { x: 0.4, y: 0.42, z: 0.35 },
    position: { x: -6.2, y: 0, z: 1.5 },
    rotation: { x: 0, y: -11.8, z: 0 },
  }
}
const camera_start_position = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
// const camera_start_position = {x:-1.6, y:0.2,z: 4}; 
// camera_start_position.position.set(-1.6, 0.2, 4);
camera_start_position.position.set(-2.5, 1.8, 8.5);

camera_start_position.rotation.y = THREE.MathUtils.degToRad(-20);
camera_start_position.rotation.x = THREE.MathUtils.degToRad(-7);


// const BackgroundFeedback = ({ currentScreenId,setModalLoaded, modalLoaded , isScreenshot ,preloadedAssets, modelsActivity = { ...defaultModelsActivity }, camera_start_pos = camera_start_position }) => {

const QuestHubLab = ({
  currentScreenId,
  setModalLoaded,
  modalLoaded,
  preloadedAssets,
  modelsActivity = { ...defaultModelsActivity },
  GlbPlayindDetails, SetGlbPlayingDetails, isZoomComplete, setIsZoomComplete, glbName, NonPlayerNameLanguage ,NonPlayerNameLanguageId,PlayerNameLanguage,
  // Default value for modelsActivity
  walkToQuest,
  onWalkComplete,
  isWalking,
  setIsWalking,
  isAnimationPaused,
  mentorNameLanguage
}) => {

  const refContainer = useRef();
  const mixerRef = useRef();
  const rendererRef = useRef(null);
  const playerMixerRef = useRef(null);
  const npcMixerRef = useRef(null);
  const clock = useRef(new THREE.Clock());
  const timeoutIds = useRef([]);

  // const [npcAnimationsRef.current, setNpcAnimations] = useState(null);
  const pcModelRef = useRef(null);
  const walkActionRef = useRef(null);
  const idleActionRef = useRef(null);

  const walkingToDoorRef = useRef(null);
  const isWalkAnimatingRef = useRef(false);
  const targetDoorPositionRef = useRef(null); 
  const isAnimationPausedRef = useRef(false);
  const sceneRef = useRef(null);
const currentBackgroundModelRef = useRef(null);
const allBackgroundModelsRef = useRef({}); // Store all loaded backgrounds
const textureLoaderRef = useRef(null);
  // STATE FOR UI UPDATES
  const [walkingToDoor, setWalkingToDoor] = useState(null);
  const [isWalkAnimating, setIsWalkAnimating] = useState(false);


  const doorPositions = useRef({
 
  '1': new THREE.Vector3(-7.70, 0.35, 6.0),
  '2': new THREE.Vector3(-11, -2.35, 2.9),
  
  '3': new THREE.Vector3(-12, -1, -0.9),
  '4': new THREE.Vector3(-15, -4, -8.9),
});
  const [glbAnimations, setGlbAnimations] = useState([]);
  const npcAnimationsRef = useRef([]);

  const pcAnimationsRef = useRef([]);
const frameCounterRef = useRef(0);
const totalDistanceMovedRef = useRef(0);

const getXZDistance = (a, b) => {
  const dx = a.x - b.x;
  const dz = a.z - b.z;
  return Math.sqrt(dx * dx + dz * dz);
};

const executeWalkToDoor = (doorNumber) => {


  walkingToDoorRef.current = doorNumber;
  isWalkAnimatingRef.current = true;
  setIsWalkAnimating(true);
  setWalkingToDoor(doorNumber);

  // Get door position
  const doorPosition = doorPositions.current[doorNumber];


  if (!doorPosition) {
    console.error(`❌ Door ${doorNumber} position not found!`);
    return;
  }

  const pcPosition = pcModelRef.current?.position;
  if (!pcPosition) {
    console.error("❌ PC position not available");
    return;
  }

  // ✅ Use ONLY door position as target
  const targetPosition = doorPosition.clone();
  targetPosition.y = pcPosition.y;

  targetDoorPositionRef.current = targetPosition;

  // Calculate total walking distance
  const dx = targetPosition.x - pcPosition.x;
  const dz = targetPosition.z - pcPosition.z;
  const totalDistance = Math.sqrt(dx * dx + dz * dz);



  // Play walk animation
  if (playerMixerRef.current && pcAnimationsRef.current) {
    playerMixerRef.current.stopAllAction();

    const walkAnim = pcAnimationsRef.current.find(anim =>
      anim.name.includes('WALK2') || anim.name.includes('Walk2')
    );

    if (walkAnim) {
      const walkAct = playerMixerRef.current.clipAction(walkAnim);
      walkAct.reset();
      walkAct.setLoop(THREE.LoopRepeat, Infinity);
      walkAct.play();
      walkActionRef.current = walkAct;

    }
  }

  // Reset counters
  frameCounterRef.current = 0;
  totalDistanceMovedRef.current = 0;

};
useEffect(() => {

}, [walkToQuest, isWalking]);

  //  HANDLE WALKING TRIGGER FROM PARENT
  useEffect(() => {
 
    
    if (walkToQuest && doorPositions.current[walkToQuest] && pcModelRef.current) {
     
      
      // Update state
      setWalkingToDoor(walkToQuest);
      walkingToDoorRef.current = walkToQuest;
      setIsWalkAnimating(true);
      isWalkAnimatingRef.current = true;
      
      // Execute walk
      executeWalkToDoor(walkToQuest);
    }
  }, [walkToQuest]);

  useLayoutEffect(() => {
    const { current: container } = refContainer;
    if (container) {
      const canvas = document.createElement('canvas');
      canvas.className = 'webgl';
      container.appendChild(canvas);
    }
    return () => {
      if (refContainer.current) {
        while (refContainer.current.firstChild) {
          refContainer.current.removeChild(refContainer.current.firstChild);
        }
      }
    };
  }, [currentScreenId]);

  useLayoutEffect(() => {
    
    const canvas = document.querySelector('canvas.webgl');
    if (!canvas) {
      
      console.error('Canvas element not found.');
      return;
    }
    const scene = new THREE.Scene();
    const light = new THREE.AmbientLight(0xffffff, 0.3);
    scene.add(light);

    const directionalLight = new THREE.DirectionalLight(0xffffff, 2.5);
    directionalLight.position.set(0.5, 0, 0.866);
    directionalLight.castShadow = true;
    scene.add(directionalLight);

    const hemiLight = new THREE.HemisphereLight();

    scene.add(hemiLight);

   const dracoLoader = new DRACOLoader();
  dracoLoader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.7/");
  
  const gltfLoader = new GLTFLoader();
  gltfLoader.setDRACOLoader(dracoLoader);
 

   const textureLoader = new THREE.TextureLoader();
      const bgSrc = preloadedAssets?.QuestHub || preloadedAssets?.preloadedGLBs?.QuestHub || null;
      if (bgSrc) {
        textureLoader.load(
          bgSrc,
          (texture) => {
            texture.encoding = THREE.sRGBEncoding;
            scene.background = texture;
            // small delay to mark loaded like FuturisticLab
            setTimeout(() => setModalLoaded && setModalLoaded(true), 800);
          },
          undefined,
          (err) => {
            console.error('QuestHub background load error:', err);
            setModalLoaded && setModalLoaded(true);
          }
        );
      } else {
        console.warn('No QuestHub background found in preloadedAssets.');
        setModalLoaded && setModalLoaded(true);
      }

  const normalizedKey1 = Object.keys(preloadedAssets?.preloadedGLBs).find(
    key => key.toLowerCase() === PlayerNameLanguage.toLowerCase()
  );
 

  const selectedPC = preloadedAssets?.preloadedGLBs?.[normalizedKey1]?.src; 
  // const selectedNPC = preloadedAssets.preloadedGLBs[NonPlayerNameLanguage];


 if(selectedPC){
  gltfLoader.load(
selectedPC,
(gltf) => {
const model = gltf.scene;
model.scale.set(1, 1, 1);
model.rotation.set(0, 2.10, 0);
model.position.set(0.48, 0.35, 1.0);
          pcModelRef.current = model;
const playerMixer = new THREE.AnimationMixer(model);
playerMixerRef.current = playerMixer;
const animations = gltf.animations;
          animations.forEach((anim, i) => {
           
          });
          
  pcAnimationsRef.current = animations;
scene.add(model);
const idleAnimation = animations.find((anim) => anim.name === 'IDLE POSE');
if (idleAnimation) {
 
  const idleAction = playerMixer.clipAction(idleAnimation);
  idleAction.reset().fadeIn(0.2).play();
            idleActionRef.current = idleAction;
}
handleAnimations(playerMixer, animations);
},
undefined,
(error) => {
console.log(`Error loading model from :`, error);
}
)
}
 
 
  let normalizedKey = "";
     if(mentorNameLanguage){
       normalizedKey = Object.entries(preloadedAssets?.preloadedGLBs).find(
        ([key, value]) => key.toLowerCase() === mentorNameLanguage.toLowerCase()
      );
     }else{
        normalizedKey = Object.entries(preloadedAssets?.preloadedGLBs).find(
         ([key, value]) => value?.uniqueId === String(NonPlayerNameLanguageId)
       );
     }
  // const selectedNPC = normalizedKey ? normalizedKey[0] : null;
  const selectedNPC = normalizedKey ? normalizedKey[1]?.src : null;


if (selectedNPC) {
  gltfLoader.load(
    selectedNPC,
    (gltf) => {
      const model = gltf.scene;
      

      model.scale.set(1, 1.02, 1);
       model.rotation.set(0, 0.8, 0);
      model.position.set(0.37, 0.35, -1.2);

      if (gltf.animations && gltf.animations.length > 0) {
        const npcMixer = new THREE.AnimationMixer(model);
        npcMixerRef.current = npcMixer; // Assign only if animations exist
        const animations = gltf.animations;
        // setNpcAnimations(animations);
          npcAnimationsRef.current = animations;
        const idleAnimation = animations.find((anim) => anim.name === 'IDLE POSE');
        if (idleAnimation) {
        
          const idleAction = npcMixer.clipAction(idleAnimation);
          idleAction.reset().fadeIn(0.2).play();
        }
        handleAnimations(npcMixer, gltf.animations);
      } else {
        console.warn("No animations found for the NPC model.");
      }

      scene.add(model);
    },
    undefined,
    (error) => {
      console.error(`Error loading NPC model:`, error);
    }
  );
} else {
  console.error(`Invalid NPC selection: ${NonPlayerNameLanguage}`);
}





    function adjustSizes() {
      let sizes = {
        width: window.innerWidth,
        height: window.innerHeight,
      };

      if (window.innerHeight > window.innerWidth) {
        sizes = {
          width: window.innerHeight,
          height: window.innerWidth,
        };
      }
      return sizes;
    }
    let sizes = adjustSizes();

   sizes = {
        width: window.innerWidth,
        height: window.innerHeight,
      };
      if (sizes.height > sizes.width) {
        [sizes.width, sizes.height] = [sizes.height, sizes.width];
      }


    const camera = new THREE.PerspectiveCamera(
      37.3,
      sizes.width / sizes.height,
      0.1,
      100
    );
    camera.position.set(4.445, 1.365, -0.041);
    camera.rotation.set(
      90.0 * (Math.PI / 180), // Convert 18.41 degrees to radians
      87.41 * (Math.PI / 180), // Convert 83.7 degrees to radians
      -90.0 * (Math.PI / 180) // Convert -18.3 degrees to radians
    );
    scene.add(camera);

    const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
    renderer.setSize(sizes.width, sizes.height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.setClearColor(0x000000, 1);
    renderer.toneMapping = THREE.LinearToneMapping;
    renderer.toneMappingExposure = 1;
    rendererRef.current = renderer;
    const resizeCallback = () => {
      sizes.width = window.innerWidth;
      sizes.height = window.innerHeight;

if (sizes.height > sizes.width) [sizes.width, sizes.height] = [sizes.height, sizes.width];
  sizes.width = sizes.width;
  sizes.height = sizes.height;


      camera.aspect = sizes.width / sizes.height;
      camera.updateProjectionMatrix();
      renderer.setSize(sizes.width, sizes.height);
    };

    window.addEventListener('resize', resizeCallback);
    let initialZoomOut = true;
    let animationFrameId;
    let frameCounter = 0;
    let totalDistanceMoved = 0;
    


const handleWalking = (delta) => {
  frameCounterRef.current++;

  // Check if we should be walking
  if (
    !walkingToDoorRef.current ||
    !pcModelRef.current ||
    !targetDoorPositionRef.current||
      isAnimationPausedRef.current
  ) {
    return;
  }

  const target = targetDoorPositionRef.current;
  const pos = pcModelRef.current.position;
  const scale = pcModelRef.current.scale;

  // Calculate distance to target
  const dx = target.x - pos.x;
  const dz = target.z - pos.z;
  const distance = Math.sqrt(dx * dx + dz * dz);

  // 🚨 INITIALIZE SCALE + POSITION TRACKING (ONCE)
  if (!window.walkInitialPos) {
    window.walkInitialPos = { x: pos.x, z: pos.z };
    window.walkInitialScale = scale.x;

  }

  // ✅ DISTANCE MOVED (DIRECTION INDEPENDENT)
  const movedX = pos.x - window.walkInitialPos.x;
  const movedZ = pos.z - window.walkInitialPos.z;
  const distanceMoved = Math.sqrt(
    movedX * movedX + movedZ * movedZ
  );

  // 🚨 SCALE BASED ON ACTUAL MOVEMENT
  const scaleIncreasePerUnit = 0.09;
  const targetScale =
    window.walkInitialScale +
    distanceMoved * scaleIncreasePerUnit;

  const newScale =
    scale.x + (targetScale - scale.x) * 0.1;

  scale.set(newScale, newScale, newScale);

  // Debug log
  if (frameCounterRef.current % 20 === 0) {
  
  }

 
if (distance < 0.3) {

  pos.x = target.x;
  pos.z = target.z;

  const idleAnim = pcAnimationsRef.current.find(
    anim => anim.name === "IDLE POSE"
  );

  if (walkActionRef.current && idleAnim) {
    const idleAction = playerMixerRef.current.clipAction(idleAnim);

    idleAction.reset();
    idleAction.fadeIn(0.4);
    idleAction.play();

    walkActionRef.current.fadeOut(0.4);

    idleActionRef.current = idleAction;
  }

  walkActionRef.current = null;

  if (onWalkComplete) {
    onWalkComplete();
  }

  walkingToDoorRef.current = null;
  targetDoorPositionRef.current = null;
  isWalkAnimatingRef.current = false;
  setIsWalkAnimating(false);
  setWalkingToDoor(null);

  delete window.walkInitialPos;
  delete window.walkInitialScale;

  return;
}
  // 🔴 MOVEMENT
  const speed = 1.5;
  const moveAmount = Math.min(speed * delta, distance);

  const dirX = dx / distance;
  const dirZ = dz / distance;

  pos.x += dirX * moveAmount;
  pos.z += dirZ * moveAmount;

  pcModelRef.current.rotation.y =
    Math.atan2(dirX, dirZ);

  totalDistanceMovedRef.current += moveAmount;

  if (frameCounterRef.current % 40 === 0) {

  }
};

const walkSpecificDistance = (distanceUnits = 5) => {

  
  if (!pcModelRef.current) return;
  
  const currentPos = pcModelRef.current.position;
  const currentRot = pcModelRef.current.rotation.y;
  
  // Calculate forward direction
  const forwardX = Math.sin(currentRot);
  const forwardZ = Math.cos(currentRot);
  
  // Calculate target position
  const target = new THREE.Vector3(
    currentPos.x + (forwardX * distanceUnits),
    currentPos.y,
    currentPos.z + (forwardZ * distanceUnits)
  );
  

  
  // Start walking
  walkingToDoorRef.current = `FORWARD_${distanceUnits}`;
  isWalkAnimatingRef.current = true;
  setIsWalkAnimating(true);
  targetDoorPositionRef.current = target;
  
  // Play animation
  if (playerMixerRef.current && pcAnimationsRef.current) {
    const walkAnim = pcAnimationsRef.current.find(anim =>
      anim.name.includes('WALK') || anim.name.includes('Walk')
    );
    if (walkAnim) {
      const walkAct = playerMixerRef.current.clipAction(walkAnim);
      walkAct.reset().setLoop(THREE.LoopRepeat, Infinity).play();
      walkActionRef.current = walkAct;
    }
  }
};




    function animate() {
      animationFrameId = requestAnimationFrame(animate);
      
      const delta = clock.current.getDelta();
      
      // Update animation mixers
      if (mixerRef.current) mixerRef.current.update(delta);
      if (playerMixerRef.current) playerMixerRef.current.update(delta);
      if (npcMixerRef.current) npcMixerRef.current.update(delta);
      
      // Update walking
      handleWalking(delta);
      
      rendererRef.current.render(scene, camera);
    }
    animate();
    return () => {
      window.removeEventListener('resize', resizeCallback);

      if (rendererRef.current) {
        rendererRef.current.dispose();
        rendererRef.current = null;
      }

      if (refContainer.current) {
        while (refContainer.current.firstChild) {
          refContainer.current.removeChild(refContainer.current.firstChild);
        }
      }
      scene.traverse((object) => {
        if (object.isMesh) {
          object.geometry.dispose();
          if (object.material.map) object.material.map.dispose();
          object.material.dispose();
        }
      });
      if (scene.environment) {
        scene.environment.dispose();
      }
      cancelAnimationFrame(animationFrameId);
    };

  }, [currentScreenId]);

 

  useEffect(() => {
    if (currentScreenId === 14) {
      if (npcMixerRef.current) {
      

        const idleAnimation = npcAnimationsRef.current.find((anim) => anim.name === 'IDLE POSE');
        if (idleAnimation) {
          const idleAction = npcMixerRef.current.clipAction(idleAnimation);
          idleAction.reset().play();
        } else {
          console.error("NPC idle animation not found");
        }
      }
  
      if (playerMixerRef.current) {
       
        const idleAnimation = pcAnimationsRef.current.find((anim) => anim.name === 'IDLE POSE');
        if (idleAnimation) {
          playerMixerRef.current.stopAllAction();
          const idleAction = playerMixerRef.current.clipAction(idleAnimation);
          idleAction.reset().play();
        } else {
          console.error("Player idle animation not found");
        }}else {
          console.error("Player Mixer Not Found");
        }
      
    }
  }, [currentScreenId, npcAnimationsRef.current, pcAnimationsRef.current]); 


  

  useEffect(() => {   
     if (isWalkAnimatingRef.current) return;
    let timeoutId;

    const cleanup = () => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutIds.current.forEach((id) => clearTimeout(id));
      timeoutIds.current = [];

      if (npcMixerRef.current && npcAnimationsRef.current) {
        npcMixerRef.current._actions.forEach((action) => {
          if (action.getClip().name !== 'IDLE POSE') {
            action.fadeOut(0.2);
          }
        });
        const idle = npcAnimationsRef.current.find(a => a.name === 'IDLE POSE');
        if (idle) npcMixerRef.current.clipAction(idle).reset().fadeIn(0.2).play();
      }

      // if (playerMixerRef.current && pcAnimationsRef.current) {
        if (playerMixerRef.current && pcAnimationsRef.current && !isWalkAnimatingRef.current) {

        playerMixerRef.current._actions.forEach((action) => {
          if (action.getClip().name !== 'IDLE POSE') {
            action.fadeOut(0.2);
          }
        });
        const idle = pcAnimationsRef.current.find(a => a.name === 'IDLE POSE');
        if (idle) playerMixerRef.current.clipAction(idle).reset().fadeIn(0.2).play();
      }
    };
    
    // if (GlbPlayindDetails && !isWalkAnimatingRef.current) {
    if (!isWalkAnimatingRef.current) {
   
      cleanup(); 
  
      if (npcMixerRef.current && npcAnimationsRef.current) {
        const idle = npcAnimationsRef.current.find(a => a.name === 'IDLE POSE');
        if (idle) npcMixerRef.current.clipAction(idle).reset().play();
      }
      
      if (playerMixerRef.current && pcAnimationsRef.current) {
        const idle = pcAnimationsRef.current.find(a => a.name === 'IDLE POSE');
        if (idle) playerMixerRef.current.clipAction(idle).reset().play();
      }
      
      timeoutId = setTimeout(() => {
        if ((GlbPlayindDetails?.whospeak === 'NPC' || GlbPlayindDetails?.whospeak === 'PC') && currentScreenId !== 14) {
         
          handleAnimations(
            GlbPlayindDetails?.whospeak === 'NPC' ? npcMixerRef.current : playerMixerRef.current,
            GlbPlayindDetails?.whospeak === 'NPC' ? npcAnimationsRef.current : pcAnimationsRef.current
          );
        }
      }, 300);
    }

    return () => {
      if (!isWalkAnimatingRef.current) {
    cleanup();
  }
    };
  }, [GlbPlayindDetails,currentScreenId]);

// Add this function near your other functions
const forceCompleteWalk = () => {
  if (walkingToDoorRef.current && pcModelRef.current && targetDoorPositionRef.current) {
  
    
    const target = targetDoorPositionRef.current;
    pcModelRef.current.position.x = target.x;
    pcModelRef.current.position.z = target.z;
    
    // Stop walk animation
    if (walkActionRef.current) {
      walkActionRef.current.stop();
    }
    
    // Play idle
    if (idleActionRef.current) {
      idleActionRef.current.reset().play();
    }
    
    // Reset
    const completedDoor = walkingToDoorRef.current;
    walkingToDoorRef.current = null;
    targetDoorPositionRef.current = null;
    isWalkAnimatingRef.current = false;
    setIsWalkAnimating(false);
    setWalkingToDoor(null);
    
    if (onWalkComplete) {
      onWalkComplete();
    }
  }
};

  function handleAnimations(mixer, animations) {
      //  timeoutIds.current = []; 
     
    const playAnimation = (mixer, animation, loop = THREE.LoopRepeat, timeScale = 1,fadeDuration=0.5) => {
     
      const action = mixer.clipAction(animation);
      action.reset().fadeIn(0.5).play();
      mixer._actions?.forEach((act) => act.fadeOut(fadeDuration)); 
      // mixer.stopAllAction();
      action.reset();
      action.loop = loop;
      action.timeScale = timeScale;
      action.fadeIn(fadeDuration);
      action.play();
      return action;
    };

    const playSequence = (mixer, animations, idleAnimation, duration) => {
      // Clear any pending timeouts
      timeoutIds.current.forEach((id) => clearTimeout(id));
      timeoutIds.current = [];
    
      // Stop all ongoing animations
      // mixer.stopAllAction();
    
      const [anim1, anim2] = animations;
      const restDuration = duration - anim1.duration;
    
      // Play the first animation
      playAnimation(mixer, anim1);
    
      // Schedule the second animation
      const id1 = setTimeout(() => {
        if (GlbPlayindDetails?.whospeak === 'NPC' || GlbPlayindDetails?.whospeak === 'PC') {
          playAnimation(mixer, anim2);
    
          // Schedule the idle animation
          const id2 = setTimeout(() => {
            if (GlbPlayindDetails?.whospeak === 'NPC' || GlbPlayindDetails?.whospeak === 'PC') {
              playAnimation(mixer, idleAnimation);
            }
          }, restDuration * 1000);
          timeoutIds.current.push(id2); // Store the timeout ID
        }
      }, anim1.duration * 1000);
      timeoutIds.current.push(id1); // Store the timeout ID
    };

    const handleIdleAnimation = (mixer, animations) => {
      const idleAnimation = animations.find((anim) => anim.name === 'IDLE POSE');
      if (idleAnimation) playAnimation(mixer, idleAnimation, THREE.LoopRepeat, 1);
    };

    const handleCharacterAnimations = (mixer, charAnimations, idleAnimation) => {
      const emotion = GlbPlayindDetails?.characteraction?.toUpperCase() || '';
      const multiAction = emotion.split(',').map((action) => action.trim());
      const duration = GlbPlayindDetails?.audioduration || 0;

      if (multiAction.length > 1) {
        const anim1 = charAnimations.find((anim) => anim.name === multiAction[0]) || idleAnimation;
        const anim2 = charAnimations.find((anim) => anim.name === multiAction[1]) || idleAnimation;
        playSequence(mixer, [anim1, anim2], idleAnimation, duration);
      } else {
        const targetAnimation = charAnimations.find((anim) => anim.name === emotion) || idleAnimation;
        playAnimation(mixer, targetAnimation);
        if (duration > 0) {
          
          // setTimeout(() => playAnimation(mixer, idleAnimation), duration * 1000);
          const time = setTimeout(() => playAnimation(mixer, idleAnimation), duration * 1000);
          timeoutIds.current.push(time)
        }
      }
    };

    // Idle for Narrator or specific screen
    if (mixer && (!GlbPlayindDetails?.whospeak || GlbPlayindDetails?.whospeak === 'Narrator' || currentScreenId === 14)) {
      handleIdleAnimation(mixer, animations);
    }

    // NPC animations
    if (mixer && npcAnimationsRef.current && GlbPlayindDetails?.whospeak === 'NPC') {
      const idleAnimation = npcAnimationsRef.current.find((anim) => anim.name === 'IDLE POSE');
      handleCharacterAnimations(mixer, npcAnimationsRef.current, idleAnimation);
    }

    // PC animations
    if (mixer && pcAnimationsRef.current && GlbPlayindDetails?.whospeak === 'PC') {
      const idleAnimation = pcAnimationsRef.current.find((anim) => anim.name === 'IDLE POSE');
      handleCharacterAnimations(mixer, pcAnimationsRef.current, idleAnimation);
    }
  }

    useEffect(() => {
        isAnimationPausedRef.current = isAnimationPaused;
    if (npcMixerRef.current) {
      
      npcMixerRef.current._actions.forEach((action) => {
        if (isAnimationPaused) {
          action.paused = true;
        } else {
          action.paused = false;
        }
      });
    }

    if (playerMixerRef.current) {
      playerMixerRef.current._actions.forEach((action) => {
        if (isAnimationPaused) {
          action.paused = true;
        } else {
          action.paused = false;
        }
      });
    }
  }, [isAnimationPaused]);
  return (
    
    <div ref={refContainer} className='000000zz' style={{ height: "100%", width: "100%", position: "absolute" }}>
      <div ref={refContainer} className='000000zz' style={{ height: "100%", width: "100%", position: "absolute" }}></div>
    
    
    </div>
  );

};


QuestHubLab.propTypes = {
  currentScreenId: PropTypes.number,
  setModalLoaded: PropTypes.func,
  modalLoaded: PropTypes.bool,
  preloadedAssets: PropTypes.shape({
    preloadedGLBs: PropTypes.shape({}),
  }),
  modelsActivity: PropTypes.shape({
    whoIsSpeaking: PropTypes.oneOf(['player', 'npc', 'narrator']),
    playerEmotions: PropTypes.arrayOf(PropTypes.string),
    npcEmotions: PropTypes.arrayOf(PropTypes.string),
    cameraPosition: PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number,
      z: PropTypes.number,
    }),
    playerModel: PropTypes.shape({
      isRequired: PropTypes.bool,
      position: PropTypes.shape({
        x: PropTypes.number,
        y: PropTypes.number,
        z: PropTypes.number,
      }),
      rotation: PropTypes.shape({
        x: PropTypes.number,
        y: PropTypes.number,
        z: PropTypes.number,
      }),
    }),
    NpcModel: PropTypes.shape({
      isRequired: PropTypes.bool,
      position: PropTypes.shape({
        x: PropTypes.number,
        y: PropTypes.number,
        z: PropTypes.number,
      }),
      rotation: PropTypes.shape({
        x: PropTypes.number,
        y: PropTypes.number,
        z: PropTypes.number,
      }),
    }),
  }),
  walkToQuest: PropTypes.string,
  onWalkComplete: PropTypes.func,
  isWalking: PropTypes.bool,
  setIsWalking: PropTypes.func,
};

QuestHubLab.defaultProps = {
  modelsActivity: defaultModelsActivity,
}
export default React.memo(QuestHubLab);

